import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withIntl } from 'ha/i18n';

import {
  getFeaturedCities,
  getLocalizedApartmentSlug,
} from 'ha/modules/FeaturedCities/selectors';
import FeaturedSuggestions from '../components/FeaturedCities/FeaturedSuggestions';

const enhance = compose(
  connect(
    createStructuredSelector({
      featuredCities: getFeaturedCities,
      localizedApartmentSlug: getLocalizedApartmentSlug,
    }),
  ),
  withIntl,
);

export default enhance(FeaturedSuggestions);
